import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** Route guard (beforeLoad): resource planning ships behind the `resources` feature flag. */
export async function requireResourcesFeature(queryClient: QueryClient): Promise<void> {
  const { flags } = await queryClient.query(featuresQuery);
  if (!flags.resources) throw notFound();
}

/** Areas and skills (RES-15, RES-16) need `resources` and `skills_and_areas`. */
export async function requireSkillsFeature(queryClient: QueryClient): Promise<void> {
  const { flags } = await queryClient.query(featuresQuery);
  if (!flags.resources || !flags.skills_and_areas) throw notFound();
}
